// Ícones de contorno (SVG inline, grade 24×24, `currentColor`) do menu, das
// ações mais comuns e dos indicadores do Dashboard. Sem dependência externa —
// modelo técnico emprestado do QA-Planning: um dicionário central de paths +
// uma função que monta o `<svg>`. Cada ícone nasceu de um conceito real da
// lavanderia, não de um kit genérico de painel — combinar com o rótulo ao
// lado (o ícone nunca é a única pista).

export type NomeIcone =
  | "dashboard"
  | "operacional"
  | "lancar-os"
  | "backlog"
  | "cronograma"
  | "financeiro"
  | "faturamento"
  | "retiradas"
  | "contas-pagar"
  | "contas-receber"
  | "cadastros"
  | "clientes"
  | "tabela-precos"
  | "tipos-peca"
  | "funcionarios"
  | "insumos"
  | "usuarios"
  | "permissoes"
  | "parametros"
  | "auditoria"
  | "plus"
  | "close"
  | "download"
  | "cesto"
  | "caixa-check"
  | "maquina-lavar"
  | "retorno"
  | "percentual"
  | "alerta"
  | "confere"
  | "info"
  | "ajustes"
  | "limpar-filtro";

const ICON_PATHS: Record<NomeIcone, string> = {
  dashboard: '<path d="M4 20V10M12 20V4M20 20v-7"/>',
  operacional:
    '<rect x="4" y="3" width="16" height="18" rx="2"/><circle cx="12" cy="13" r="5"/><circle cx="7.2" cy="6" r="1"/><circle cx="10.2" cy="6" r="1"/>',
  "lancar-os":
    '<path d="M4 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4z"/><path d="M15 6.5v11" stroke-dasharray="2.2 2.2"/>',
  backlog:
    '<path d="M4 12h4l2 3h4l2-3h4"/><path d="M4 12V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v6"/><path d="M4 12v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6"/>',
  cronograma: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>',
  financeiro: '<circle cx="9" cy="9" r="6"/><circle cx="15" cy="15" r="6"/>',
  faturamento: '<path d="M6 3h12v17l-2-1.2-2 1.2-2-1.2-2 1.2-2-1.2-2 1.2z"/><path d="M9 8h6M9 12h6"/>',
  retiradas: '<rect x="3" y="7" width="18" height="12" rx="2"/><path d="M3 10h18"/><circle cx="16" cy="14" r="1.3"/>',
  "contas-pagar": '<rect x="4" y="12" width="16" height="8" rx="1.5"/><path d="M12 12V3"/><path d="M7.5 8 12 3.5 16.5 8"/>',
  "contas-receber": '<rect x="4" y="12" width="16" height="8" rx="1.5"/><path d="M12 3v9"/><path d="M7.5 8 12 12.5 16.5 8"/>',
  cadastros: '<rect x="3" y="4" width="18" height="6" rx="1"/><rect x="3" y="14" width="18" height="6" rx="1"/><path d="M9 7h2M9 17h2"/>',
  clientes:
    '<rect x="4" y="3" width="16" height="18" rx="1"/><path d="M9 21v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4"/><path d="M8 7h.01M12 7h.01M16 7h.01M8 11h.01M12 11h.01M16 11h.01"/>',
  "tabela-precos": '<path d="M12 3h6a2 2 0 0 1 2 2v6l-9 9-8-8 9-9z"/><circle cx="16.4" cy="7.6" r="1.4"/>',
  "tipos-peca": '<rect x="4" y="4" width="16" height="16" rx="2"/><path d="M4 9.3h16M4 14.7h16"/>',
  funcionarios: '<circle cx="12" cy="8" r="3.2"/><path d="M5 20c0-4 3-6 7-6s7 2 7 6"/>',
  insumos: '<path d="M12 3s6 7 6 11a6 6 0 0 1-12 0c0-4 6-11 6-11z"/>',
  usuarios:
    '<rect x="4" y="4" width="16" height="16" rx="2"/><circle cx="9.5" cy="10" r="2"/><path d="M6.5 16c0-1.7 1.4-2.6 3-2.6s3 .9 3 2.6M14 9h3.5M14 13h3.5"/>',
  // escudo com check: Perfil é quem define o que cada Usuário pode acessar.
  permissoes: '<path d="M12 3 19 6v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/>',
  // porca sextavada, não engrenagem de raios: um "sol" de 8 raios lê como
  // ícone de brilho/tema, não de configuração.
  parametros: '<path d="M12 2.3 19.5 6.7v8.6L12 19.7 4.5 15.3V6.7z"/><circle cx="12" cy="11" r="3.3"/>',
  auditoria: '<path d="M12 8v4l3 2"/><path d="M4.5 9A8 8 0 1 1 4 13"/><path d="M2 8l1.6 4 3.2-2.4"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  close: '<path d="M6 6l12 12M18 6L6 18"/>',
  download: '<path d="M12 3v10"/><path d="M7.5 9 12 13.5 16.5 9"/><path d="M4 18h16"/>',
  // controles deslizantes, não engrenagem: a engrenagem do topo já é o menu de administração.
  ajustes:
    '<path d="M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1"/><circle cx="15" cy="6" r="2"/><circle cx="9" cy="12" r="2"/><circle cx="17" cy="18" r="2"/>',
  "limpar-filtro": '<path d="M3 4h17l-6.5 7.8V18l-4 2v-8.2z"/><path d="M16 15l5 5m0-5-5 5"/>',
  // --- indicadores do Dashboard (issue #23) ---
  cesto:
    '<path d="M5 10h14l-1.5 9a2 2 0 0 1-2 1.7H8.5a2 2 0 0 1-2-1.7L5 10z"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/><path d="M9 13v5M12 13v5M15 13v5"/>',
  "caixa-check": '<rect x="4" y="6" width="16" height="14" rx="2"/><path d="M9 13l2 2 4-4"/>',
  // desenho diferente do ícone `operacional` (drum + 2 botões) — mesmo
  // conceito de máquina de lavar, mas outro traço, pra não repetir o ícone
  // de navegação do menu num card de indicador sem relação com ele.
  "maquina-lavar":
    '<rect x="4" y="3" width="16" height="18" rx="2"/><circle cx="12" cy="13" r="5"/><path d="M9 13c.8-1.6 4.2-1.6 5 0"/><circle cx="8" cy="6" r="1"/>',
  // seta que volta — peça que retorna do Cliente (ADR-0016: identificada por ele).
  retorno: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10a6 6 0 0 1 0 12h-2"/>',
  percentual: '<circle cx="7" cy="7" r="2.2"/><circle cx="17" cy="17" r="2.2"/><path d="M18 6 6 18"/>',
  // Backlog Inicial negativo (ADR-0019): sinal de cadastro incompleto, não de
  // erro do sistema — por isso um alerta discreto, não vermelho de erro.
  alerta: '<path d="M12 3 22 20H2z"/><path d="M12 10v4"/><circle cx="12" cy="17" r="0.1"/>',
  // "como é calculado": abre a dica de um indicador do Dashboard
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><circle cx="12" cy="7.8" r="0.1"/>',
  // o par do `alerta` nas linhas de situação: a conta da peça confere.
  confere: '<path d="M5 12.5 9.5 17 19 7.5"/>',
};

const SVG_NS = "http://www.w3.org/2000/svg";

/**
 * Um ícone pronto pra anexar na tela: contorno, `fill:none`, extremidades
 * arredondadas, cor sempre herdada de `currentColor` (a menos que `stroke`
 * seja passado). `tamanho` default 16 — o `viewBox` continua 24×24.
 */
export function icon(
  nome: NomeIcone,
  tamanho = 16,
  opts?: { stroke?: string; peso?: number },
): SVGElement {
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("width", String(tamanho));
  svg.setAttribute("height", String(tamanho));
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("fill", "none");
  svg.setAttribute("stroke", opts?.stroke ?? "currentColor");
  svg.setAttribute("stroke-width", String(opts?.peso ?? 2));
  svg.setAttribute("stroke-linecap", "round");
  svg.setAttribute("stroke-linejoin", "round");
  svg.setAttribute("aria-hidden", "true");
  svg.innerHTML = ICON_PATHS[nome];
  return svg;
}

/**
 * `[icon(nome, tamanho)]` quando `nome` vem, `[]` quando não — pra espalhar
 * (`...iconeOpcional(x.icone)`) num `el(...)` sem repetir o ternário em cada
 * lugar que desenha um item de menu com ícone opcional.
 */
export function iconeOpcional(nome: NomeIcone | undefined, tamanho = 16): SVGElement[] {
  return nome ? [icon(nome, tamanho)] : [];
}
